// 微信相关
import to from 'await-to-js';
import * as apis from "@/api/interface/mttf";

export default {
  namespaced: true,
  state: () => ({
    loading: {},
    zxToMofangList: undefined,  // 增转魔方数据统计 - 列表
    launchMonitor: undefined,
    inventoryConfigList: undefined, //库存配置 - 列表
    mediaAccountList: undefined, //媒体账户管理 - 列表
    financeBillList: undefined, //财务流水 - 列表
  }),
  getters: {
  },
  mutations: {
    update(state, payload) {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
      });
    },
  },
  actions: {
    // 增转魔方数据统计 - 列表
    async getZxToMofangList(ctx, payload={}) {
      const [err, res] = await to(apis.getZxToMofangList(payload));
      ctx.commit("update", {
        zxToMofangList: !err && res.data ? res.data : undefined,
      });
    },
    async getLaunchMonitor(ctx, payload={}) {
      const [err, res] = await to(apis.getLaunchMonitor(payload));
      ctx.commit("update", {
         launchMonitor: !err && res.data ? res.data : undefined,
      });
    },



    // 库存配置 - 列表
    async getInventoryConfigList(ctx, payload = {}) {
      const [err, res] = await to (apis.getInventoryConfigList(payload));
      ctx.commit("update", {
        inventoryConfigList: !err && res.data ? res.data : undefined,
      });
    },
    // 库存配置 - 新增、修改
    async inventoryConfigAddOrUpdate(ctx, payload = {}) {
      const [, res] = await to(apis.inventoryConfigAddOrUpdate(payload));
      return res;
    },
    // 库存配置 - 删除
    async inventoryConfigDelete(ctx, payload = {}) {
      const [, res] = await to(apis.inventoryConfigDelete(payload));
      return res;
    },
    // 库存配置 - 模板下载
    async inventoryConfigExport(ctx, payload = {}) {
      const [, res] = await to(apis.inventoryConfigExport(payload));
      return res;
    },
    // 库存配置 - 数据导入
    async inventoryConfigUpload(ctx, payload = {}) {
      const [, res] = await to(apis.inventoryConfigUpload(payload));
      return res;
    },




    // 媒体账户管理 - 菜单选项
    async getMediaPlatformOptions(ctx, payload = {}) {
      const [, res] = await to (apis.getMediaPlatformOptions(payload));
      return res;
    },
    // 媒体账户管理 - 列表
    async getMediaAccountList(ctx, payload = {}) {
      const [err, res] = await to (apis.getMediaAccountList(payload));
      ctx.commit("update", {
        mediaAccountList: !err && res.data ? res.data : undefined,
      });
    },
    // 媒体账户管理 - 子账户编辑
    async mediaSubAccountUpdate(ctx, payload = {}) {
      const [, res] = await to (apis.mediaSubAccountUpdate(payload));
      return res;
    },


    // 媒体代理商选项
    async getAdAgentOptions(ctx, payload = {}) {
      const [, res] = await to(apis.getAdAgentOptions(payload));
      return res;
    },
    // 财务流水 - 数据导出
    async financeBillExport(ctx, payload = {}) {
      const [, res] = await to(apis.financeBillExport(payload));
      return res;
    },
    // 财务流水 - 列表
    async getFinanceBillList(ctx, payload = {}) {
      const [err, res] = await to (apis.getFinanceBillList(payload));
      ctx.commit("update", {
        financeBillList: !err && res.data ? res.data : undefined,
      });
    },



    // 现金消耗 - 期模板下载
    async cashConsumeDownTemplate(ctx, payload = {}) {
      const [, res] = await to(apis.cashConsumeDownTemplate(payload));
      return res;
    },
    // 现金消耗 - 上传excel表
    async cashConsumeUpload(ctx, payload = {}) {
      const [, res] = await to(apis.cashConsumeUpload(payload));
      return res;
    },
  },
  modules: {
  }
}
